export enum Constants {
    PROFILE_SET_EMAILS = 'PROFILE_SET_EMAILS',
    PROFILE_SET_MOBILE = 'PROFILE_SET_MOBILE',
}
